<template>
  <div>
    <el-form ref="form" :model="form" label-width="100px">
      <el-row>
        <el-col span="6">
          <el-form-item label="车场名称:">
            <selectSearch  v-model="form.spaceId"  @change="spaceIdChange" :dicData="spacelist"></selectSearch>
            <!-- <el-select
              v-model="form.spaceId"
              @change="spaceIdChange"
              style="width: 100%"
              placeholder="车场名称"
            >
              <el-option
                v-for="item in spacelist"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              ></el-option>
            </el-select> -->
          </el-form-item>
        </el-col>
        <el-col span="6">
          <el-form-item label="车牌号:">
            <el-input v-model="form.carNo" placeholder="车牌号" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col span="12">
          <el-form-item
            :label="activeName == 'outPark' ? '出场时间:' : '入场时间:'"
            id="datetimerange"
          >
            <el-date-picker
              v-model="form.dateTime"
              type="datetimerange"
              range-separator="至"
              style="width: 370px"
              start-placeholder="开始时间"
              :clearable="false"
              end-placeholder="结束时间"
            >
            </el-date-picker>
            <el-radio-group
              style="margin-left: 10px"
              v-model="cycNum"
              @change="searchFormcycNumChange"
            >
              <el-radio :label="1">天</el-radio>
              <el-radio :label="2">周</el-radio>
              <el-radio :label="3">月</el-radio>
              <el-radio :label="4">季</el-radio>
              <el-radio :label="5">半年</el-radio>
              <el-radio :label="6">年</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col span="6">
          <el-form-item label="车辆分类:">
            <el-select v-model="form.carType" style="width: 100%" clearable placeholder="车辆分类">
              <el-option label="临时车" value="临时车"></el-option>
              <el-option label="月卡车" value="月卡车"></el-option>
              <el-option label="固定车" value="固定车"></el-option>
              <el-option label="白名单" value="白名单"></el-option>
              <el-option label="储值车" value="储值车"></el-option>
              <el-option label="过期车" value="过期车"></el-option>
              <el-option label="未生效月卡车" value="未生效月卡车"></el-option>
              <el-option label="跨区月卡车" value="跨区月卡车"></el-option>
              <el-option label="外来临时车" value="外来临时车"></el-option>
              <el-option label="业主临时车" value="业主临时车"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="6" >
          <el-form-item label="车牌颜色:">
            <el-select
              v-model="form.plateColor"
              style="width: 100%"
              clearable
              placeholder="车牌颜色"
            >
              <el-option
                v-for="item in plateColor"
                :key="item.id"
                :label="item.dictValue"
                :value="item.dictValue"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="6">
          <el-form-item label="入场通道:">
            <el-select
              v-model="form.inPassageId"
              style="width: 100%"
              clearable
              placeholder="入场通道"
            >
              <el-option
                v-for="item in InPassageList"
                :key="item.id"
                :label="item.passageName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="6" v-if="activeName == 'remainPark'">
          <el-form-item label="车位组名称:">
            <el-select
              v-model="form.carGroupId"
              style="width: 100%"
              clearable
              placeholder="车位组名称"
            >
              <el-option
                v-for="item in carGroupList"
                :key="item.id"
                :label="item.carParkGroupName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="24" v-if="activeName=='remainPark'">
          <el-form-item style="text-align: right">
            <el-checkbox v-model="form.overTwentyFour">在场时长超过24小时</el-checkbox>
          </el-form-item>
        </el-col>
        <el-col span="6" v-if="activeName == 'outPark'">
          <el-form-item label="出场通道:">
            <el-select
              v-model="form.outPassageId"
              style="width: 100%"
              clearable
              placeholder="出场通道"
            >
              <el-option
                v-for="item in OutPassageList"
                :key="item.id"
                :label="item.passageName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="6" v-if="activeName == 'outPark'">
          <el-form-item label="支付方式:">
            <el-select
              v-model="form.payType"
              @change="payTypeChange"
              style="width: 100%"
              clearable
              placeholder="支付方式"
            >
              <el-option
                v-for="item in payTypeList"
                :key="item.id"
                :label="item.dictValue"
                :value="item.dictValue"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="6" v-if="activeName == 'outPark'">
          <el-form-item label="操作类型:">
            <el-select v-model="form.operate" style="width: 100%" clearable placeholder="操作类型">
              <el-option
                v-for="item in operateList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="6" v-if="activeName == 'outPark'">
          <el-form-item label="应缴总额:">
            <el-input
              placeholder="应缴总额"
              v-model="shouldAccount"
              :disabled="true"
              style="color: red"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col span="6" v-if="activeName == 'outPark'">
          <el-form-item label="实缴总额:">
            <el-input placeholder="实缴总额" v-model="realityAccount" :disabled="true"> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="activeName=='intoPark'?24:activeName=='remainPark'?24:24" style="text-align:right">
          <el-button size="small" icon="el-icon-search" type="primary" @click="searchSubmit()"
            >搜 索</el-button
          >
          <el-button size="small" icon="el-icon-delete" @click="searchReset()">清 空</el-button>
        </el-col>

      </el-row>
    </el-form>
  </div>
</template>
<script>
import { getInPassage, getOutPassage, getAllGroupBySpaceId } from '@/api/v4ward/carv2/carinoutinfo';
import { getDictionary } from '@/api/common';
export default {
  props: {
    spacelist: {
      type: Array,
      default() {
        return [];
      },
    },
    activeName: 'intoPark',
    shouldAccount: '0.00',
    realityAccount: '0.00',
  },
  watch: {
    spacelist() {
      this.form.spaceId = this.spacelist[0] ? this.spacelist[0].id : '';
      this.temSpaceId = this.form.spaceId;
      this.searchSubmit();
      this.spaceIdChange(this.temSpaceId);
    },
  },
  data() {
    return {
      loading: false,
      temSpaceId: '',
      InPassageList: [],
      OutPassageList: [],
      carGroupList: [],
      payTypeList: [],
      plateColor: [],
      operateList: [
        {
          value: '0',
          label: '等待开闸',
        },
        {
          value: '1',
          label: '自动开闸',
        },
        {
          value: '2',
          label: '手动开闸',
        },
        {
          value: '3',
          label: '遥控开闸',
        },
      ],
      cycNum: '',
      form: {
        overTwentyFour:false,
        plateColor:"",
        dateTime: [
          this.dayjs(this.dayjs().format('YYYY-MM-DD 00:00:00')).subtract(1, 'day'),
          this.dayjs().format('YYYY-MM-DD 23:59:59'),
        ],
      },
    };
  },
  created() {
    this.initData();
  },
  methods: {
    searchSubmit() {
      this.temSpaceId = this.form.spaceId;
      this.loading = true;
      this.$emit('searchChange', this.form, () => {
        this.loading = false;
      });
    },
    searchReset() {
      this.cycNum = '';
      this.form = {
        spaceId: this.temSpaceId,
        overTwentyFour: false,
        dateTime: [
          this.dayjs(this.dayjs().format('YYYY-MM-DD 00:00:00')).subtract(1, 'day'),
          this.dayjs().format('YYYY-MM-DD 23:59:59'),
        ],
      };
      this.loading = true;
      this.$emit('searchReset', this.form, () => {
        this.loading = false;
      });
    },
    searchClear() {
      this.cycNum = '';
      this.form = {
        spaceId: this.temSpaceId,
        overTwentyFour: false,
        dateTime: [
          this.dayjs(this.dayjs().format('YYYY-MM-DD 00:00:00')).subtract(1, 'day'),
          this.dayjs().format('YYYY-MM-DD 23:59:59'),
        ],
      };
    },
    payTypeChange(val) {
      this.form.payType = val;
      console.log(val);
      this.$forceUpdate();
    },
    searchFormcycNumChange(val) {
      if (!Boolean(this.form.dateTime.length)) {
        return;
      }
      switch (val) {
        case 1:
          this.form.dateTime = [
            this.dayjs(this.dayjs().format('YYYY-MM-DD 00:00:00')),
            this.dayjs().format('YYYY-MM-DD 23:59:59'),
          ]
          break;
        case 2:
          this.form.dateTime = [
            this.dayjs(this.dayjs().format('YYYY-MM-DD 00:00:00')).subtract(1, 'week'),
            this.dayjs().format('YYYY-MM-DD 23:59:59'),
          ];
          break;
        case 3:
          this.form.dateTime = [
            this.dayjs(this.dayjs().format('YYYY-MM-DD 00:00:00')).subtract(1, 'month'),
            this.dayjs().format('YYYY-MM-DD 23:59:59'),
          ];
          break;
        case 4:
          this.form.dateTime = [
            this.dayjs(this.dayjs().format('YYYY-MM-DD 00:00:00')).subtract(3, 'month'),
            this.dayjs().format('YYYY-MM-DD 23:59:59'),
          ];
          break;
        case 5:
          this.form.dateTime = [
            this.dayjs(this.dayjs().format('YYYY-MM-DD 00:00:00')).subtract(6, 'month'),
            this.dayjs().format('YYYY-MM-DD 23:59:59'),
          ];
          break;
        case 6:
          this.form.dateTime = [
            this.dayjs(this.dayjs().format('YYYY-MM-DD 00:00:00')).subtract(12, 'month'),
            this.dayjs().format('YYYY-MM-DD 23:59:59'),
          ];
          break;
      }
    },
    spaceIdChange(spaceId) {
      getInPassage({ spaceId: spaceId }).then((res) => {
        this.InPassageList = res.data;
      });
      getOutPassage({ spaceId: spaceId }).then((res) => {
        this.OutPassageList = res.data;
      });
      getAllGroupBySpaceId({ spaceId: spaceId }).then((res) => {
        this.carGroupList = res.data;
      });
    },
    initData() {
      getDictionary('tempcar_pay_type').then((data) => {
        this.payTypeList = data.data;
      });
      getDictionary('identity_plate_color').then((data) => {
        this.plateColor = data.data;
      });
    },
  },
};
</script>
<style>
#datetimerange .el-form-item__content {
  display: flex;
  align-items: center;
}
</style>
